import { DEV, EDITOR } from 'cc/env';
import { CCString, Component, _decorator } from 'cc';
import I18n from '../../../I18n/I18n';
import Delay from '../../Utils/Delay';
import LocalizedComponent from './LocalizedComponent';

const { ccclass, property } = _decorator;

@ccclass('LocalizedAsset')
export default abstract class LocalizedAsset<T extends Component> extends LocalizedComponent<T> {
    @property(CCString)
    private _key: string = '';

    // to be compatible with old version since 'key' property is renamed to 'assetKey'
    public set key(key: string) {
        this.assetKey = key;
    }
    public get key(): string {
        return this.assetKey;
    }

    // property named 'key' would cause a bug in animation panel of editor, so we use 'assetKey' instead but still display as 'key' for readability
    @property({ type: CCString, displayName: DEV && 'key' })
    private set assetKey(key: string) {
        this._key = key;
        if (!EDITOR) {
            this._invokeOnKeyChange();
        }
    }
    private get assetKey(): string {
        return this._key;
    }

    protected onLanguageChange() {
        this._invokeOnKeyChange();
    }

    private async _invokeOnKeyChange() {
        if (!this.i18n.currentLanguage) {
            if (this.i18n.isLoadingLanguage) {
                await this.i18n.waitForLanguageLoaded();
            } else {
                await Delay.event(I18n.EVENT_TYPE.LanguageChanged, this.game.i18n);
            }
        }
        if (!this.key) {
            return;
        }
        this.onKeyChange();
    }

    public abstract reset(): void;

    protected abstract onKeyChange(): void;
}
